var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-items-modal" },
    [
      _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.active,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.active = $event
            },
          },
        },
        [
          _c("div", { staticClass: "model-content" }, [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(" Create a New Template "),
                ]),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _vm.isLoading || _vm.isSaving
                  ? _c(
                      "div",
                      { staticClass: "spinner-container" },
                      [
                        _c("spinner", {
                          attrs: {
                            message: _vm.isLoading ? "Loading.." : "Saving...",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c(
                          "label",
                          { staticClass: "label is-required-label" },
                          [_vm._v("Template Name")]
                        ),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.templateName,
                                expression: "templateName",
                              },
                            ],
                            staticClass: "input",
                            class: {
                              "is-danger":
                                !_vm.templateName ||
                                _vm.templateName == "" ||
                                !_vm.isTemplateNameValid,
                            },
                            attrs: {
                              type: "text",
                              placeholder: "Enter Quote Template name",
                              maxlength: "30",
                            },
                            domProps: { value: _vm.templateName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.templateName = $event.target.value
                              },
                            },
                          }),
                          _c("div", { staticClass: "help is-secondary" }, [
                            _vm._v(
                              " " + _vm._s(_vm.templateName.length) + "/30 "
                            ),
                          ]),
                          !_vm.isTemplateNameValid
                            ? _c("div", { staticClass: "tags" }, [
                                _c("span", { staticClass: "tag is-danger" }, [
                                  _vm._v(
                                    " Name already in use, choose a different name "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-one-third" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Add Tag"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "control",
                            staticStyle: { position: "relative" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown",
                                class: { "is-active": _vm.tagDropdownActive },
                                staticStyle: { width: "100%" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-trigger",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input tag-input-fake",
                                        on: { click: _vm.toggleDropdown },
                                      },
                                      [
                                        _vm.selectedTags.length
                                          ? _vm._l(
                                              _vm.selectedTags,
                                              function (tag) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: tag.tagID,
                                                    staticClass:
                                                      "tag-short mr-1",
                                                    style: {
                                                      backgroundColor:
                                                        tag.colorHex,
                                                      color: _vm.getTextColor(
                                                        tag.colorHex
                                                      ),
                                                      marginBottom: "2px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(tag.shortTag) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e(),
                                        !_vm.selectedTags.length
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#b5b5b5",
                                                },
                                              },
                                              [_vm._v("Add tags")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "icon is-right",
                                            staticStyle: {
                                              "pointer-events": "none",
                                              position: "absolute",
                                              right: "10px",
                                              top: "10px",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "mdi mdi-menu-down",
                                            }),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _c("TagsDropdownMenu", {
                                  attrs: {
                                    tags: _vm.tags,
                                    "selected-tags": _vm.selectedTagIDs,
                                    "is-visible": _vm.tagDropdownActive,
                                  },
                                  on: {
                                    "toggle-tag": _vm.toggleTag,
                                    "clear-all-tags": _vm.clearAllTags,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-bar mb-4 p-4" }, [
                    _c("div", { staticClass: "columns is-mobile" }, [
                      _c("div", { staticClass: "column is-half" }, [
                        _c("div", { staticClass: "info-section" }, [
                          _c("div", { staticClass: "has-text-weight-bold" }, [
                            _vm._v("Quote Labour Times"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-2 has-text-weight-bold has-text-primary",
                            },
                            [_vm._v(_vm._s(_vm.quote.labourType))]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-half" }, [
                        _c("div", { staticClass: "info-section" }, [
                          _c("div", { staticClass: "has-text-weight-bold" }, [
                            _vm._v("Vehicle Body Style"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-2 has-text-weight-bold has-text-primary",
                            },
                            [_vm._v(_vm._s(_vm.bodyTypeValue?.name || "N/A"))]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "category-item-grid mb-5 mt-5 pb-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "is-flex is-justify-content-start" },
                        [
                          _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pretty p-icon p-curve p-smooth p-bigger",
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    type: "checkbox",
                                    id: "quote-template-items-checkbox-all-items",
                                    name: "quote-template-items-checkbox-all-items",
                                  },
                                  domProps: { checked: _vm.areAllSelected },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectAll(!_vm.areAllSelected)
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "state p-primary" }, [
                                  _c("i", {
                                    staticClass: "icon mdi mdi-check",
                                  }),
                                  _c("label"),
                                ]),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "is-flex is-justify-content-end" },
                            [
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v(" Select All "),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c("div"),
                    ]
                  ),
                  _c(
                    "div",
                    _vm._l(_vm.dataTypes, function (type, index) {
                      return _c(
                        "div",
                        {
                          key: type.key + index,
                          staticClass: "category-item-grid mb-2 pb-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "is-flex is-justify-content-start" },
                            [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-icon p-curve p-smooth p-bigger",
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        disabled:
                                          _vm.itemLengths[type.key] == 0,
                                        id: "quote-template-items-checkbox-all-items",
                                        name: "quote-template-items-checkbox-all-items",
                                      },
                                      domProps: {
                                        checked: _vm.isSelected(type),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectItems(type)
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "state p-primary" },
                                      [
                                        _c("i", {
                                          staticClass: "icon mdi mdi-check",
                                        }),
                                        _c("label"),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v(" " + _vm._s(type.title) + " "),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "is-flex is-justify-content-end" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mr-2 has-text-weight-bold has-text-grey-dark",
                                },
                                [_vm._v(_vm._s(_vm.itemLengths[type.key]))]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _c(
                "footer",
                {
                  staticClass: "modal-card-foot",
                  style: `justify-content: flex-end`,
                },
                [
                  _c(
                    "button",
                    { staticClass: "button", on: { click: _vm.close } },
                    [
                      _c(
                        "span",
                        { staticClass: "material-symbols-outlined mr-1" },
                        [_vm._v(" close ")]
                      ),
                      _c("span", [_vm._v(" Cancel ")]),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      attrs: { disabled: _vm.isDisabled },
                      on: { click: _vm.createNewTemplate },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "material-symbols-outlined mr-2" },
                        [_vm._v(" save ")]
                      ),
                      _c("span", [_vm._v("Save")]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }